import moment from "moment";
export const openModalHandler = (setismodalOpen,ismodalOpen)=>{
    setismodalOpen(!ismodalOpen);
}

const currentDate = new Date();

export const DefaultTime = moment(currentDate);

export const currentDateTime = new Date().toISOString();